import React from 'react';
import { LockIcon, ZapIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="relative z-10 py-24 px-4 bg-gradient-to-b from-transparent to-[#111836]" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <FadeIn className="glass-card p-8 md:p-12 text-center border-amber-500/30 box-glow relative overflow-hidden" data-id="element-105">
          {/* Subtle warm glow behind the offer */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[200%] h-[200%] bg-amber-500/5 blur-[120px] pointer-events-none" data-id="element-106"></div>

          <div className="relative z-10" data-id="element-107">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-serif" data-id="element-108">
              Recupera tus noches y tu energía por menos de lo que cuesta un
              café y un postre.
            </h2>

            <p className="text-xl text-gray-300 mb-10" data-id="element-109">
              Obtén el sistema completo hoy mismo.
            </p>

            <div className="mb-10" data-id="element-110">
              <span className="inline-block px-4 py-1.5 rounded-full bg-amber-500/20 text-amber-400 font-semibold text-sm tracking-wide uppercase mb-4 border border-amber-500/30" data-id="element-111">
                Precio Especial de Lanzamiento
              </span>
              <div className="flex items-center justify-center gap-4" data-id="element-112">
                <span className="text-3xl text-gray-500 line-through decoration-rose-500/50 decoration-2" data-id="element-113">
                  $19.99
                </span>
                <span className="text-6xl md:text-7xl font-bold text-white text-glow" data-id="element-114">
                  $6.36{' '}
                  <span className="text-2xl text-gray-400 font-normal" data-id="element-115">
                    USD
                  </span>
                </span>
              </div>
            </div>

            <a href="https://app.komvii.com/checkout/HCrDx1jix17PmEwfRB98oC5fnWeWpmTW?p=MjUw" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-flex items-center justify-center w-full md:w-auto px-10 py-5 text-xl font-bold text-slate-900 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full hover:from-amber-300 hover:to-amber-400 transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_40px_rgba(245,158,11,0.6)] transform hover:-translate-y-1 animate-[pulse_2s_infinite]" data-id="element-116">
              ¡QUIERO DORMIR BIEN HOY!
            </a>

            <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-400" data-id="element-117">
              <div className="flex items-center gap-2" data-id="element-118">
                <ZapIcon className="w-4 h-4 text-amber-500" data-id="element-119" />
                <span data-id="element-120">Acceso instantáneo después del pago.</span>
              </div>
              <div className="hidden md:block w-1 h-1 rounded-full bg-gray-600" data-id="element-121"></div>
              <div className="flex items-center gap-2" data-id="element-122">
                <LockIcon className="w-4 h-4 text-green-500" data-id="element-123" />
                <span data-id="element-124">Pago 100% seguro.</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}